import type { ReactNode } from 'react';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
  hoverable?: boolean;
  as?: 'div' | 'article' | 'section';
}

export function GlassCard({
  children,
  className = '',
  onClick,
  href,
  hoverable = true,
  as: Component = 'div',
}: GlassCardProps) {
  const baseClasses = `
    bg-white border border-border rounded-2xl shadow-sm
    ${hoverable ? 'transition-all duration-300 ease-in-out hover:border-gray-300 hover:-translate-y-0.5 hover:shadow-md' : ''}
    ${onClick || href ? 'cursor-pointer' : ''}
    ${className}
  `.trim();

  if (href) {
    if (href.startsWith('http')) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`block ${baseClasses}`}
          style={{ boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)' }}
        >
          {children}
        </a>
      );
    }
    return (
      <Component
        className={baseClasses}
        onClick={onClick}
        style={{ boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)' }}
      >
        {children}
      </Component>
    );
  }

  return (
    <Component
      className={baseClasses}
      onClick={onClick}
      style={{ boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)' }}
    >
      {children}
    </Component>
  );
}
